document.addEventListener("DOMContentLoaded", function() {

	let header = document.getElementById('header');	

	let open_sub_menu = false;

	function open_child_menu(event) {

		let keyboard_navigation = document.body.classList.contains('show-focus-outlines');

		//if this is mobile and the event is a mouseover, ignore any events
		if(window.matchMedia("(max-width: 1024px)").matches && event.type == "mouseover") {
			return;
		}


		// If we're hovering over a parent link or a sub-menu
		if (event.target.matches('#menu-main-nav') || event.target.matches('#menu-main-nav-1') || event.target.matches('.desktop-parent-link-toggle') || event.target.matches('.sub-menu') || event.target.matches('.mobile-menu-item')) {
		
			if(event.target.matches('.desktop-parent-link-toggle') && event.target.nextSibling) {

				if(keyboard_navigation && !event.target.classList.contains('active')) {
					event.preventDefault();
				}

				let parent_classes = event.target.parentElement.classList;
				let parent_id = false;

				//loop through each parent (li) classes
				for(let i = 0; i < parent_classes.length; i++) {

					//save the current class for easier reference
					let current_class =  parent_classes[i];

					//if this is the menu item ID
					if(current_class.includes("menu-item-") && (/\d/g).test(current_class)) {

						//save it
						parent_id = current_class;
						break;
					}
				}

				//this will help us determine if the same element has been clicked multiple times
				let same_origin = parent_id === open_sub_menu;

				//if this is not a mouseover event
				if(event.type != "mouseover") {
					//close all menus
					close_child_menu();
				}

				//if it was a different item
				if(!same_origin) {
					//close all menus
					close_child_menu();

					//open sub-menu
					event.target.classList.add('active');
					open_sub_menu = parent_id;
				} else {
					event.target.classList.remove('active');
				}
			}

			
		} else {
			//close all menus
			close_child_menu();
		}
	}

	// Add an event listener to the document to listen for the "keydown" event
	document.addEventListener('keydown', function(event) {
		// Check if the pressed key is the "Esc" key (key code 27)
		if (event.keyCode === 27) {
			// Trigger the close_child_menu() function
			close_child_menu();
		}
	});

	if ( header ) {
        header.addEventListener('click', open_child_menu, false);
    }


	document.addEventListener('mouseover', open_child_menu, false);

	function close_child_menu() {

		let header = document.getElementById('header');

        if ( header ) {
            //fetch open menus
            let open_menus = header.getElementsByClassName('active');

            //if we have some open menus
            if(open_menus) {

                //loop through then
                for(let i = 0; i < open_menus.length; i++) {

                    //close them
                    open_menus[i].classList.remove('active');
                }
            }

            open_sub_menu = false;
        }

	
	}

	document.addEventListener('click', function (event) {

		// If the clicked element isn't the hamburger, return
		if (!event.target.matches('.hamburger')) return;

		//scroll back to the top of the page
		window.scroll({top: 0, left: 0});

		//toggle the active class on the mobile nav
		document.body.classList.toggle('nav-open');
	}, false);

    // Get the element with ID 'mobile-nav'
    var mobileNav = document.getElementById('mobile-nav');

    if (mobileNav) {

        // Add click event listener to the common ancestor (nav with id 'mobile-nav')
        mobileNav.addEventListener('click', function(event) {
            // Check if the clicked element or its ancestor matches the desired selector
            if (event.target.closest('.menu-item-has-children > a')) {
            // Get the clicked element
            var clickedElement = event.target.closest('.menu-item-has-children > a');
    
            // Get the current click count (default to 0 if not set)
            var clickCount = parseInt(clickedElement.getAttribute('data-click-count')) || 0;
    
            // Check the click count
            if (clickCount === 0) {
                // On the first click, prevent the default behavior and add the 'active' class
                event.preventDefault();
                clickedElement.classList.add('active');
            } else {
                // On the second click, allow the default behavior and remove the 'active' class
                clickedElement.classList.remove('active');
                close_child_menu();
            }
    
            // Increment the click count
            clickedElement.setAttribute('data-click-count', clickCount + 1);
            }
        });
    }
});
  